<div class="p-col content" style="min-width:400px;">
    <p-card>
        <div class="grid">
            <p-table responsiveLayout="scroll" [value]="openSourcePackages" styleClass="p-datatable-striped"
                [metaKeySelection]="true" [paginator]="true" [lazy]="false" rows="10" [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [rowsPerPageOptions]="[10,25,50]" [totalRecords]="this.openSourcePackages.length" [scrollable]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th>
                            <div class="icon-title-th"><label>Package</label></div>
                        </th>
                        <th>
                            <div class="icon-title-th"><label>License</label></div>
                        </th>
                        <th>
                            <div class="icon-title-th"><label>URL</label></div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-openSourcePackage let-i="rowIndex">
                    <tr>
                        <td>{{openSourcePackage.packageName}}</td>
                        <td><a href="{{openSourcePackage.licenseUrl}}">{{openSourcePackage.licenseType}}</a></td>
                        <td><a href="{{openSourcePackage.packageUrl}}">{{openSourcePackage.packageUrl}}</a></td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-card>
</div>